export default "<p>modal-cost-delete works!</p>\n"